type StorageItem = string | number | boolean | object | null;

class LocalStorageUtil {
  private static isAvailable(): boolean {
    const test = "test";
    try {
      localStorage.setItem(test, test);
      localStorage.removeItem(test);
      return true;
    } catch (e) {
      return false;
    }
  }

  static setItem(key: string, value: StorageItem): void {
    if (!this.isAvailable()) {
      console.warn("localStorage is not available");
      return;
    }

    try {
      const serializedValue = JSON.stringify(value);
      localStorage.setItem(key, serializedValue);
    } catch (e) {
      console.error("Error saving to localStorage:", e);
    }
  }

  static getItem<T extends StorageItem>(key: string, defaultValue: T): T {
    if (!this.isAvailable()) {
      console.warn("localStorage is not available");
      return defaultValue;
    }

    try {
      const item = localStorage.getItem(key);
      if (item === null) {
        return defaultValue;
      }
      return JSON.parse(item) as T;
    } catch (e) {
      console.error("Error retrieving from localStorage:", e);
      console.error("Error retrieving key:", key);

      return defaultValue;
    }
  }

  static removeItem(key: string): void {
    if (!this.isAvailable()) {
      console.warn("localStorage is not available");
      return;
    }

    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.error("Error removing item from localStorage:", e);
    }
  }

  static clear(): void {
    if (!this.isAvailable()) {
      console.warn("localStorage is not available");
      return;
    }

    try {
      localStorage.clear();
    } catch (e) {
      console.error("Error clearing localStorage:", e);
    }
  }
}

export default LocalStorageUtil;
